export default __webpack_public_path__ + "static/media/daily_horoscope_7-sixteen_nine.ded9b9b4.jpg";